Object.defineProperty(exports,"__esModule",{value:true});exports.default=

{

UPDATE_PUCK_STATE:'UPDATE_PUCK_STATE',
UPDATE_LOCK_STATE:'UPDATE_LOCK_STATE',
UPDATE_ALARM_MODULE_STATE:'UPDATE_ALARM_MODULE_STATE',
UPDATE_SECURITY_DEVICE_HEALTH_STATE:'UPDATE_SECURITY_DEVICE_HEALTH_STATE',
UPDATE_SECURE_PLUG_STATE:'UPDATE_SECURE_PLUG_STATE',
UPDATE_CX_FLEX_STATE:'UPDATE_CX_FLEX_STATE',
UPDATE_RAM_STATE:'UPDATE_RAM_STATE',
UPDATE_FM20_STATE:'UPDATE_FM20_STATE',
UPDATE_PROXIMITY_PUCK_STATE:'UPDATE_PROXIMITY_PUCK_STATE',
UPDATE_NXDI_PUCK_STATE:'UPDATE_NXDI_PUCK_STATE',


UPDATE_POSITION_RULE_STATE:'UPDATE_POSITION_RULE_STATE',
UPDATE_FIXTURE_RULE_STATE:'UPDATE_FIXTURE_RULE_STATE',


UPDATE_STORE_INQUIRY:'UPDATE_STORE_INQUIRY',
UPDATE_STORE_RULE_INQUIRY:'UPDATE_STORE_RULE_INQUIRY',
UPDATE_SECURITY_DEVICE_INQUIRY:'UPDATE_SECURITY_DEVICE_INQUIRY',
UPDATE_FIXTURE_INQUIRY:'UPDATE_FIXTURE_INQUIRY',
UPDATE_FIXTURE_RULE_INQUIRY:'UPDATE_FIXTURE_RULE_INQUIRY',
UPDATE_POSITION_INQUIRY:'UPDATE_POSITION_INQUIRY',
UPDATE_POSITION_RULE_INQUIRY:'UPDATE_POSITION_RULE_INQUIRY',
UPDATE_RULE_INQUIRY:'UPDATE_RULE_INQUIRY',
UPDATE_PRODUCT_INQUIRY:'UPDATE_PRODUCT_INQUIRY',
UPDATE_SECURED_PRODUCT_INQUIRY:'UPDATE_SECURED_PRODUCT_INQUIRY',
UPDATE_KEY_STATE:'UPDATE_KEY_STATE',


DELETE_STORE_INQUIRY:'DELETE_STORE_INQUIRY',
DELETE_STORE_RULE_INQUIRY:'DELETE_STORE_RULE_INQUIRY',
DELETE_SECURITY_DEVICE_INQUIRY:'DELETE_SECURITY_DEVICE_INQUIRY',
DELETE_FIXTURE_INQUIRY:'DELETE_FIXTURE_INQUIRY',
DELETE_FIXTURE_RULE_INQUIRY:'DELETE_FIXTURE_RULE_INQUIRY',
DELETE_POSITION_INQUIRY:'DELETE_POSITION_INQUIRY',
DELETE_POSITION_RULE_INQUIRY:'DELETE_POSITION_RULE_INQUIRY',
DELETE_PRODUCT_INQUIRY:'DELETE_PRODUCT_INQUIRY',
DELETE_SECURED_PRODUCT_INQUIRY:'DELETE_SECURED_PRODUCT_INQUIRY'};